// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 404) return "static/css/404.d3c723c9e.chunk.css";
	// return url for filenames based on template
	return undefined;
};